import {post,get} from '../../libs/ajax.js'

export default {

    /* 创意团队 */

    // 配置管理-创意团队列表
    getTeamConfigList:(data,options) => {
        return get('/work_order/team_config/get_list', data, options);
    },
    // 配置管理-保存创意团队
    saveTeamConfig:(data,options) => {
        return post('/work_order/team_config/save', data, options);
    },
    // 配置管理-编辑创意团队
    updateTeamConfig:(data,options) => {
        return post('/work_order/team_config/update', data, options);
    },
    // 配置管理-创意团队-详情
    getTeamConfigInfo:(data,options) => {
        return get('/work_order/team_config/get_detail', data, options);
    },
    // 配置管理-删除创意团队
    deleteTeamConfig:(data,options) => {
        return post('/work_order/team_config/delete', data, options);
    },
    // 配置管理-创意团队-获取制作部门
    getTeamConfigGroup:(data,options) => {
        return get('/work_order/team_config/get_group', data, options);
    },

    /* 投放尺寸 */

    // 配置管理-投放尺寸列表
    getSizeConfigList:(data,options) => {
        return post('/work_order/tag_config/get_list', data, options);
    },
    // 配置管理-获取投放场景/投放版位
    getDeliveryOptions:(data,options) => {
        return get('/work_order/get_delivery_list', data, options);
    },
    // 配置管理-创建投放尺寸
    saveSizeConfig:(data,options) => {
        return post('/work_order/tag_config/save', data, options);
    },
    // 配置管理-编辑投放尺寸
    updateSizeConfig:(data,options) => {
        return post('/work_order/tag_config/update', data, options);
    },
    // 配置管理-删除投放尺寸
    deleteSizeConfig:(data,options) => {
        return post('/work_order/tag_config/delete', data, options);
    },
    // 配置管理-投放尺寸-详情
    getSizeConfigInfo:(data,options) => {
        return get('/work_order/tag_config/get_detail', data, options);
    },
    // 配置管理-投放尺寸-获取媒体
    getSizeConfigPlatList:(data,options) => {
        return get('/work_order/get_plat_list', data, options);
    },
    // 获取素材的格式
    getMaterialFormat:(data,options) => {
        return get('/work_order/tag_config/get_material_format', data, options);
    },
    //
    getSearchList:(data,options) => {
        return get('/work_order/tag_config/get_search_list', data, options);
    },


    /* 图片&视频标签 */
    // 配置管理-视频标签列表
    getVideoLabelConfigList:(data,options) => {
        return get('/work_order/label_video_config/get_list', data, options);
    },
    // 配置管理-创建视频标签
    saveVideoLabel1:(data,options) => {
        return post('/work_order/label_video_config/save_level1', data, options);
    },
    // 配置管理-创建视频标签
    saveVideoLabel2:(data,options) => {
        return post('/work_order/label_video_config/save_level2', data, options);
    },
    // 配置管理-编辑视频标签
    updateVideoLabelConfig:(data,options) => {
        return post('/work_order/label_video_config/update', data, options);
    },
    // 配置管理-删除视频标签
    deleteVideoLabelConfig:(data,options) => {
        return post('/work_order/label_video_config/delete', data, options);
    },
    // 配置管理-启用视频标签
    enableVideoLabelConfig:(data,options) => {
        return post('/work_order/label_video_config/enable', data, options);
    },
    // 配置管理-图片标签列表
    getImageLabelConfigList:(data,options) => {
        return get('/work_order/label_config/get_list', data, options);
    },
    // 配置管理-创建图片标签
    saveImageLabel1:(data,options) => {
        return post('/work_order/label_config/save_level1', data, options);
    },
    // 配置管理-创建图片标签
    saveImageLabel2:(data,options) => {
        return post('/work_order/label_config/save_level2', data, options);
    },
    // 配置管理-编辑图片标签
    updateImageLabelConfig:(data,options) => {
        return post('/work_order/label_config/update', data, options);
    },
    // 配置管理-删除图片标签
    deleteImageLabelConfig:(data,options) => {
        return post('/work_order/label_config/delete', data, options);
    },
    // 配置管理-启用图片标签
    enableImageLabelConfig:(data,options) => {
        return post('/work_order/label_config/enable', data, options);
    },


    // 配置管理-工单标签
    getWorkOrderLabelConfigList:(data,options) => {
        return get('/work_order/work_order_label_config/get_list', data, options);
    },
    // 配置管理-工单标签-创建
    saveWorkOrderLabelConfigInfo:(data,options) => {
        return post('/work_order/work_order_label_config/save', data, options);
    },
    // 配置管理-工单标签-编辑
    editWorkOrderLabelConfigInfo:(data,options) => {
        return post('/work_order/work_order_label_config/edit', data, options);
    },
    // 配置管理-工单标签-停用
    disableWorkOrderLabelConfigInfo:(data,options) => {
        return post('/work_order/work_order_label_config/disable', data, options);
    },
    // 配置管理-工单标签-启用
    enableWorkOrderLabelConfigInfo:(data,options) => {
        return post('/work_order/work_order_label_config/enable', data, options);
    },

    // 配置管理-产能管理-列表
    getProductionCapacityConfigList:(data,options) => {
        return get('/work_order/production_capacity_config/get_list', data, options);
    },
    // 配置管理-产能管理-创建
    saveProductionCapacityConfigInfo:(data,options) => {
        return post('/work_order/production_capacity_config/save', data, options);
    },
    // 配置管理-产能管理-编辑
    editProductionCapacityConfigInfo:(data,options) => {
        return post('/work_order/production_capacity_config/edit', data, options);
    },
    // 配置管理-产能管理-删除
    deleteProductionCapacityConfigInfo:(data,options) => {
        return post('/work_order/production_capacity_config/delete', data, options);
    },
    // 配置管理-产能管理-历史
    getProductionCapacityConfigHistoryList:(data,options) => {
        return get('/work_order/production_capacity_config/get_history_list', data, options);
    },
    // 配置管理-产能管理-建议部门
    getProductionCapacityConfigSuggestDepartmentList:(data,options) => {
        return get('/work_order/production_capacity_config/get_suggest_departments_list', data, options);
    },

    /* ===== 排单排期v2 阶段1 ===== */

    // 添加部门弹框：按数据范围返回真实组织子树（选制作组用）
    getSchedulingGroups:(data,options) => {
        return get('/work_order/scheduling/group_options', data, options);
    },
    // 产能配置-已纳入制作组列表(自下而上，含上级部门，日产能面板用)
    getCapacityConfigGroups:(data,options) => {
        return get('/work_order/capacity/config_groups', data, options);
    },
    // 产能配置-添加部门(制作组纳入)
    addCapacityConfigGroup:(data,options) => {
        return post('/work_order/capacity/add_group', data, options);
    },
    // 产能配置-移除部门(制作组移出)
    removeCapacityConfigGroup:(data,options) => {
        return post('/work_order/capacity/remove_group', data, options);
    },
    // 产能配置-设置大类组视频/平面类型(识别不出时手选)
    setCapacityCategoryType:(data,options) => {
        return post('/work_order/capacity/set_category_type', data, options);
    },

    // 产能标签树-按组取树
    getCapacityLabelTree:(data,options) => {
        return get('/work_order/capacity_label/get_tree', data, options);
    },
    // 产能标签树-加一级（2026-07-22 起产能配置页不再调用：新增改为随「保存日产能」的 added_items 一起提交；接口保留）
    saveCapacityLabel1:(data,options) => {
        return post('/work_order/capacity_label/save_label1', data, options);
    },
    // 产能标签树-加二级（同上，页面已不调用）
    saveCapacityLabel2:(data,options) => {
        return post('/work_order/capacity_label/save_label2', data, options);
    },
    // 产能标签树-改
    updateCapacityLabel:(data,options) => {
        return post('/work_order/capacity_label/update', data, options);
    },
    // 产能标签树-删
    deleteCapacityLabel:(data,options) => {
        return post('/work_order/capacity_label/delete', data, options);
    },
    // 产能标签树-批量保存末层日产能（统一改完一次提交）
    batchUpdateCapacityDaily:(data,options) => {
        return post('/work_order/capacity_label/batch_update_daily', data, options);
    },
    // 产能配置-历史修改记录
    getCapacityHistory:(data,options) => {
        return post('/work_order/capacity/history', data, options);
    },

    // 扩充产能-列表
    getCapacityExpandList:(data,options) => {
        return post('/work_order/capacity_expand/get_list', data, options);
    },
    // 扩充产能-新增
    saveCapacityExpand:(data,options) => {
        return post('/work_order/capacity_expand/save', data, options);
    },
    // 扩充产能-删
    deleteCapacityExpand:(data,options) => {
        return post('/work_order/capacity_expand/delete', data, options);
    },

    // 渠道占比-列表
    getChannelRatioList:(data,options) => {
        return post('/work_order/channel_ratio/get_list', data, options);
    },
    // 渠道占比-保存(批量upsert)
    saveChannelRatio:(data,options) => {
        return post('/work_order/channel_ratio/save', data, options);
    },
    // 渠道占比-删
    deleteChannelRatio:(data,options) => {
        return post('/work_order/channel_ratio/delete', data, options);
    },

    // 集团星级-列表(聚合四维+筛选+分页)
    getBlocStarList:(data,options) => {
        return post('/work_order/bloc_star/get_list', data, options);
    },
    // 集团星级-筛选项字典
    getBlocStarSearchOptions:(data,options) => {
        return get('/work_order/bloc_star/get_search_options', data, options);
    },
    // 集团星级-集团远程搜索(下拉·名称/ID·多选回显·批量)
    searchBlocs:(data,options) => {
        return post('/work_order/bloc_star/search', data, options);
    },
    // 集团星级-保存(单个/批量,回写排序键①)
    saveBlocStar:(data,options) => {
        return post('/work_order/bloc_star/save', data, options);
    },
    // 集团星级-单行编辑(维度字段+星级·维度冲突返回 code 40001 + 冲突行详情)
    updateBlocStar:(data,options) => {
        return post('/work_order/bloc_star/update', data, options);
    },
    // 集团星级-导入 经 el-upload action 直传 /td/api/work_order/bloc_star/import

}
